"use client";

import { useState, useCallback } from "react";

interface PressCopyBlockProps {
  text: string;
  label?: string;
  className?: string;
}

export default function PressCopyBlock({
  text,
  label,
  className = "",
}: PressCopyBlockProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Fallback for older browsers
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  }, [text]);

  return (
    <div className={`group relative ${className}`}>
      {label && (
        <p className="text-xs font-semibold uppercase tracking-wider text-gray-400 mb-2">
          {label}
        </p>
      )}
      <div className="relative rounded-lg border border-gray-200 bg-gray-50 p-4">
        <p className="text-sm leading-relaxed text-gray-700 pr-16 whitespace-pre-line">
          {text}
        </p>
        <button
          onClick={handleCopy}
          className="absolute top-3 right-3 px-3 py-1.5 text-xs font-medium rounded-md border border-gray-300 bg-white text-gray-600 hover:bg-gray-100 hover:text-gray-900 transition-colors"
          aria-label={`Copy ${label || "text"} to clipboard`}
        >
          {copied ? "Copied!" : "Copy"}
        </button>
      </div>
    </div>
  );
}
